import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Subtext = styled(Text)({
    display: "inline",
});

export const GenericIconContainer = styled.div(({ theme }) => ({
    display: "inline-flex",
    marginLeft: theme.spacing.xxSmall,
    verticalAlign: "bottom",
    marginBottom: "3px",
}));
